// Interesting take on isolated vs redux components: https://medium.com/netscape/component-state-vs-redux-store-1eb0c929277
// Slow rendering: https://github.com/amcharts/amcharts4/issues/723
import React, { Component } from 'react';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import { HistogramChartContainer } from './styles';

import _ from 'lodash';
import { ID_GRAPH_AXIS } from '../../pageDefinition/constants/idDefinition';
import { FONT_SIZES } from '../../styles/constants';
import { sendAdobeEvent } from '../../utils/analytics/adobe';
import { APP_NAME } from '../../utils/constants/general';

import { connect } from 'react-redux';

const mapStateToProps = state => ({
	defaultMappingName: state.designDefinition.partDefinition.defaultMappingName,
	wpn: state.designDefinition.partDefinition.wpn
});

class HistogramAmChart extends Component {
	componentDidMount() {
		this.initChart();
	}

	componentDidUpdate(prevProps) {
		// Handle refreshing the chart when the dataset changes
		if (!_.isEqual(prevProps.data, this.props.data)) {
			if (this.chart) {
				this.chart.dispose();
			}

			this.initChart();
		}
	}

	componentWillUnmount() {
		if (this.chart) {
			this.chart.dispose();
		}
	}

	initChart() {
		const { data, chartDescription, displayInput } = this.props;
		am4core.options.commercialLicense = true;
		am4core.addLicense('CH2281-6107-0011-9579');
		// Create chart instance
		this.chart = am4core.create(chartDescription.id, am4charts.XYChart);
		this.chart.numberFormatter.numberFormat = '#.##a';

		function formatString(str) {
			if (!str) return '';
			str = str.replace(/<sub>/g, '[baseline-shift: sub; font-size: 11px;]');
			str = str.replace(/<\/sub>/g, '[/]');
			return str;
		}

		/* Title */
		const title = this.chart.titles.create();
		if (displayInput) {
			title.text =
				chartDescription.mainHeading +
				` @ ${formatString(displayInput.heading + '</sub>')} = ${displayInput.value} ${displayInput.unit}`;
		} else {
			title.text = chartDescription.mainHeading;
		}
		title.fontSize = FONT_SIZES.SUBTITLE2;
		title.marginBottom = 30;

		// Add data
		this.chart.data = data.barChartItems;

		/* X axis */
		var categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
		const xAxeDef = chartDescription.axis.find(axe => {
			return axe.id === ID_GRAPH_AXIS.X;
		});
		categoryAxis.title.text = xAxeDef.heading + ' [[' + xAxeDef.unit + ']]';
		categoryAxis.fontSize = FONT_SIZES.BODY2;
		categoryAxis.title.fontSize = FONT_SIZES.BODY1;
		categoryAxis.title.paddingBottom = 10;
		categoryAxis.tooltip.fontSize = FONT_SIZES.BODY2;
		categoryAxis.renderer.minGridDistance = 50;
		categoryAxis.renderer.grid.template.location = 0;
		categoryAxis.dataFields.category = 'from';
		categoryAxis.renderer.minGridDistance = 30;
		categoryAxis.renderer.labels.template.rotation = 45;

		/* Y axis */
		var valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
		const yAxeDef = chartDescription.axis.find(axe => {
			return axe.id === ID_GRAPH_AXIS.Y1;
		});
		valueAxis.title.text = yAxeDef.heading + (yAxeDef.unit && ' [[' + yAxeDef.unit + ']]');
		valueAxis.fontSize = FONT_SIZES.BODY2;
		valueAxis.title.fontSize = FONT_SIZES.BODY1;
		valueAxis.tooltip.fontSize = FONT_SIZES.BODY2;

		// Create series
		var series = this.chart.series.push(new am4charts.ColumnSeries());
		series.dataFields.valueY = 'count';
		series.dataFields.categoryX = 'from';
		// eslint-disable-next-line no-useless-concat
		series.columns.template.tooltipText = '{from} - {to}' + ' [[' + xAxeDef.unit + ']]' + '\n[bold]Count: {count}[/]';

		this.chart.exporting.filePrefix =
			'SPICE Live Model chart - ' + chartDescription.chartType + ' - ' + chartDescription.simulationType;
		this.chart.exporting.menu = new am4core.ExportMenu();
		this.chart.exporting.menu.items[0].label = '';
		this.chart.exporting.menu.items[0].icon =
			'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgBAMAAAAQtmoLAAAAHlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3KG9qAAAACnRSTlMA/0sEDFdvq8OPbB5ywwAAAMVJREFUeAHt0YEFwwAYROGoKAE8SHWLjBFAR0hnyATdIN245HBBm0MbqP8AeD5cc+xqNYBfBRVUUEEFFZyGbdDeYnCft8HYN2FnLoOD9sGUAJgdjNAngJUAWAGYErASACuQiCciAARw3Q06RAAIYNk5ygTAFgB4E5gAMPAxMAFgYC8Q4S0xEAEgIAYiDORAhIEciBAQAxMGctAZyIEJAznoDOTAhIEcdAJyYEJADkwYiIEIAzEQYSAH2p8GFeQdH1RQq329F+enTePQEFWtAAAAAElFTkSuQmCC';

		this.chart.exporting.events.on('exportfinished', event => {
			sendAdobeEvent(
				'Chart',
				window.location.href,
				APP_NAME + ' | ' + this.props.defaultMappingName,
				null,
				this.props.simulationName + ' - ' + this.props.chartDescription.mainHeading + ' - ' + event.format,
				this.props.wpn
			);
		});
	}

	render() {
		return <HistogramChartContainer id={this.props.chartDescription.id} className="histogram-container" />;
	}
}

export default connect(mapStateToProps)(HistogramAmChart);
